import { apiClient } from "@/services/HttpService";

export function fetchDocListPermission() {
  return apiClient.get("/doc-list/permissions");
}

export function fetchManageProgressPermission(){
  return apiClient.get("/manage-progress/permissions");
}